import angular from 'angular';
import zebraService from '../../services/zebra.service.js';
import searchController from './search.controller.js';
import adHocSearchController from './adHocSearch.controller.js';
import browseController from './browse.controller.js';

export default angular.module('components.search', [zebraService])
    .component('adHocSearch', {
        bindings: {
            text: '@',
            catalogid: '<',
            type: '@',
            docid: '<',
            schemasList: '<',
            facetsList: '<',
            rsnList: '<',
            sortKeysList: '<',
            hitsList: '<'
        },
        template: require('./adHocSearch.pug')(),
        controller: adHocSearchController
    })
    .component('search', {
        template: require('./search.pug')(),
        bindings: {
            type: '@',
            catalogid: '@',
            facetsList: '<',
            rsnList: '<',
            schemasList: '<',
            sortKeysList: '<',
            onNext: '&', 
            onNextLabel: '@', 
            onNext2: '&', 
            onNext2Label: '@'
        },
        controller: searchController
    })
    .component('search2', {
        type: '@',
        template: require('./search2.pug')(),
        bindings: {
            catalogid: '@',
            facetsList: '<',
            rsnList: '<',
            attributesList: '<',
            materialsList: '<',
            schemasList: '<',
            sortKeysList: '<'
        },
        controller: searchController
    })
    .component('documentsList', {
        bindings: {
            type: '@',
            catalogid: '@',
            content: '<'
        },
        template: require('./documentsList.pug')()
    })
    .component('documentsListItem', {
        bindings: {
            type: '@',
            catalogid: '@',
            item: '<'
        },
        template: require('./documentsListItem.pug')()
    })
    .component('documentsListItemMenu', {
        bindings: {
            type: '@',
            catalogid: '@',
            item: '<'
        },
        template: require('./documentsListItemMenu.pug')()
    })
    .component('facet', {
        bindings: {
            facetspec: '<',
            querystr: '<',
            catalogid: '@',
            onSelect: '&'
        },
        template: require('./facet.pug')(),
        controller: ['SearchConfig', 'ZebraService', function(SearchConfig, ZebraService) {
            var ctrl = this;

            ctrl.$onInit = function() {
                load();
            };

            ctrl.$onChanges = function(changes) {
                if (changes) {
                    if (changes.querystr) {
                        ctrl.querystr = changes.querystr.currentValue;
                        load();
                    }
                }
            };

            ctrl.selectItem = function(item) {
                item.facetspec = ctrl.facetspec;
                ctrl.onSelect({item: item});
            };

            ctrl.isActive = function(cql, index, item) {
                var apt = index + '="' + item.DATA + '"';
                if (cql) { 
                    return cql.includes(apt);
                } else {
                    return false;
                }
            };

            ////////
            
            function load() {
                var qs  = {
                    id: ctrl.catalogid,
                    operation: 'search',
                    query: ctrl.querystr,
                    recordSchema: ctrl.facetspec.schema,
                    maximumRecords: 1
                };

                console.log('load facet', ctrl.facetspec);

                ZebraService.get(qs).$promise.then(function(response) {
                    ctrl.response = response; 
                }, function(err) {
                    console.log(err.message || err);
                });
            }

        }]
    })
    .component('facetItem', {
        template: require('./facetItem.pug')(),
        bindings: {
            active: '@',
            item: '<',
            onSelect: '&'
        },
        controller: function() {
            var ctrl = this;

            ctrl.$onChanges = function(changes) {
                if (changes) {
                    if (changes.item) {
                        ctrl.item = changes.item.currentValue;
                    }
                }
            };

            ctrl.select = function() {
                ctrl.onSelect({item: ctrl.item});
            };
        }
    })
    .component('rsn', {
        bindings: {
            rsnspec: '<',
            querystr: '<',
            catalogid: '@',
            onSelect: '&'
        },
        template: require('./rsn.pug')(),
        controller: ['SearchConfig', 'ZebraService', function(SearchConfig, ZebraService) {
            var ctrl = this;

            ctrl.$onInit = function() {
                console.log('rsn:oninit()');
                if (0) {
                    load();
                }
            };

            ctrl.$onChanges = function(changes) {
                console.log('rsn:onchanges()');
                if (changes) {
                    if (changes.querystr) {
                        ctrl.querystr = changes.querystr.currentValue;
                        load();
                    }
                }
            };

            ctrl.selectItem = function(item) {
                console.log('selectItem():', item);
                item.rsnspec = ctrl.rsnspec;
                console.log('selectItem(): updated', item);
                ctrl.onSelect({item: item});
            };

            ctrl.isActive = function(cql, index, item) {
                var apt = index + '="' + item.term + '"';
                if (cql) { 
                    return cql.includes(apt);
                } else {
                    return false;
                }
            };

            ////////
            
            function load() {
                console.log('load()');
                var qs  = {
                    id: ctrl.catalogid,
                    operation: 'search',
                    query: ctrl.querystr,
                    recordSchema: ctrl.rsnspec.schema,
                    maximumRecords: 1,
                    facetsEnable: 0,
                    rsnEnable: 1,
                    extraRequestData: ctrl.rsnspec.query 
                };

                console.log('load RSN', ctrl.rsnspec);

                ZebraService.get(qs).$promise.then(function(response) {
                    ctrl.response = response; 
                }, function(err) {
                    console.log(err.message || err);
                });
            }

        }]
    })
    .component('rsnItem', {
        template: require('./rsnItem.pug')(),
        bindings: {
            active: '@',
            item: '<',
            onSelect: '&'
        },
        controller: function() {
            var ctrl = this;

            ctrl.$onChanges = function(changes) {
                if (changes) {
                    if (changes.item) {
                        ctrl.item = changes.item.currentValue;
                    }
                }
            };

            ctrl.select = function() {
                ctrl.onSelect({item: ctrl.item});
            };
        }
    })
    .component('browse', {
        bindings: {
            catalogid: '@',
            index: '@',
            term: '<',
            onSelect: '&'
        },
        template: require('./browse.pug')(),
        controller: browseController
    })
    .component('termsList', {
        bindings: {
            content: '<',
            onSelect: '&'
        },
        template: require('./termsList.pug')(),
        controller: function () {
            var ctrl = this;

            ctrl.selectedItem = function(item) {
                console.log('selected item', item);
                ctrl.onSelect({item: item});
            };

        }
    })
    .component('termsListItem', {
        bindings: {
            item: '<',
            onSelect: '&'
        },
        template: require('./termsListItem.pug')(),
        controller: function() {
            var ctrl = this;

            ctrl.$onChanges = function(changes) {
                if (changes) {
                    if (changes.item) {
                        ctrl.item = changes.item.currentValue;
                    }
                }
            };

            ctrl.select = function() {
                console.log('select', ctrl.item);
                ctrl.onSelect({item: ctrl.item});
            };
        }

    })
    .value('SearchConfig', {
        type: 'default',
        catalogid: 1, // default value
        goSearch2: null,
        facetsList: [
            {name: __("Author"), index: 'dc.creator', schema: 'zebra::facet::author:p:10'},
            {name: __("Subject heading"), index: 'dc.subject', schema: 'zebra::facet::subject-heading:p:10'},
            {name: __("Publisher"), index:'dc.publisher', schema: 'zebra::facet::publisher:p:10'},
            {name: __("Publication date"), index: 'dc.date', schema: 'zebra::facet::date-of-publication:w:10'},
            {name: __("Inventory"), index: 'cuba.999b', schema: 'zebra::facet::cuba-999-b:w:10'}
        ],
        rsnList: [
            //{name: __("Year of publication"), index: 'dc.date', query: 'cuba.dateNarrow=2021', schema: 'marcxml'},
            //{name: __("eHolding collection"),  index: 'cuba.project_tpu_987m', query: 'cuba.project_tpu_987m_Facet=z', schema: 'marcxml'}
            //{name: __("Author"), query: 'cuba.authorNarrow=а', schema: 'FIXME!'},
            //{name: __("Subject heading"),  query: 'cuba.subjectNarrow=а', schema: 'FIXME!'}
        ],
        upperBound: 1000,
        maxSize: 10,
        maximumTerms: 50, 
        hitsList: [
            {name: "1", value: 1},
            {name: "5", value: 5},
            {name: "10", value: 10},
            {name: "20", value: 20},
            {name: "50", value: 50}
        ],
        schemasList: [
            {name: __("BIB v1.1"), value: "bibv1.1"}, 
            {name: __("BIB"), value: "bib"}, 
            {name: __("Portal"), value: "portal"}, 
            {name: __("MARC"), value: "marcxml"} 
        ],
        sortKeysList: [
            {name: __('Relevant'), value:''},
            //{name: 'РелевRecord key ue:'cql.sortByRecordLinkingAscending=0'},
            {name: __('Publication date (new)'), value:'cql.sortByDateDescending=0'},
            {name: __('Publication date (old)'), value:'cql.sortByDateAscending=0'},
            {name: __('Author (A-Z)'), value:'cql.sortByAuthorAscending=0', glyphicon: 'glyphicon glyphicon-sort-by-alphabe'},
            {name: __('Author (Z-A)'), value:'cql.sortByAuthorDescending=0', grlyphicon: 'glyphicon glyphicon-sort-by-alphabet-alt'},
            {name: __('Record key (ascending)'), value:'cql.sortByLocalNumberAscending=0'},
            {name: __('Record key (descending)'), value:'cql.sortByLocalNumberDescending=0'},
        ],
        relationsList: [
            {name: __('exactly'), value: '='},
            {name: __('any'), value: 'any'},
            {name: __('all'), value: 'all'}
        ],
        attributesList: [
            {name: __('Title'), value: 'dc.title'},
            {name: __('Author'), value: 'dc.creator'},
            {name: __('Discipline'), value: 'dc.subject'},
            {name: __('ISBN'), value: 'bath.isbn'},
            {name: __('ISSN'), value: 'bath.issn'},
            {name: __('Year of publication'), value: 'dc.date'},
            {name: __('Geographic location'), value: 'cuba.placePublication'},
            {name: __('Publisher'), value: 'dc.publisher'},
            {name: __('All fields'), value: 'cql.serverChoice'},
            {name: __('Universal Decimal Classification'), value: 'cuba.classificationUDC'},
            {name: __('Library-Bibliographical Classification'), value: 'cuba.classificationLocal'},
            {name: __('OKSVNK Classification'), value: 'cuba.classificationLocal'},
            {name: __('Record insertion date'), value: 'cuba.dateAddedToDB'},
            {name: __('Record identifier'), value: 'rec.id'},
            //{name: __('Все записи?'), value: 'cql.allRecords'},
            {name: __('Exhibition name'), value: 'cql.cuba.exhibition'},
            {name: __('Exhibition identifier'), value: 'cql.cuba.exhibitionCode'},
            {name: __('Discipline name'), value: 'cql.cuba.discipline'}
        ],
        materialsList: [
            {name:__("All content types"), value:""},
            /*
            {name:"Монографические", value:"cuba.bibLevel=m"},
            {name:"Аналитические", value:"cuba.bibLevel=a"},
            {name:"Подборки", value:"cuba.bibLevel=c"},
            {name:"Интегрируемые ресурсы", value:"cuba.bibLevel=i"},
            */
            {name:__("Books"), value:"(cuba.bibLevel=m and (cuba.recordType=a or cuba.recordType=b))"},
            {name:__("Journals [by name]"), value:"(cuba.bibLevel=s and (cuba.recordLinking=1 or cuba.recordLinking=0))"},
            {name:__("Journals [issues, volumes]"), value:"(cuba.bibLevel=s and cuba.recordLinking=2)"},
            {name:__("Abstracts Journals"), value:"(cuba.bibLevel=s and dc.format=d)"},
            {name:__("Articles"), value:"cuba.bibLevel=a"},
            {name:__("Video Recordings"), value:"cuba.recordType=g"},
            {name:__("Audio Recordings"), value:"(cuba.recordType=i or cuba.recordType=j)"},
            {name:__("Electronic Resources"), value:"cuba.recordType=l"},
            {name:__("Bibliographic publications"), value:"dc.format=a"},
            {name:__("Dissertations/Thesis"), value:"(dc.format=m or dc.format=d)"},
            {name:__("Government Documents"), value:"((cuba.bibLevel=s and dc.format=l) or (cuba.bibLevel=m and dc.format=n))"},
            {name:__("Maps"), value:"(cuba.recordType=e or cuba.recordType=f)"},
            {name:__("Sheet Music"), value:"(cuba.recordType=c or cuba.recordType=d)"},
            {name:__("Technical Reports"), value:"dc.format=p"},
            {name:__("Patents"), value:"(cuba.bibLevel=m and dc.format=k)"},
            {name:__("Industrial Catalogs"), value:"dc.format=b"},
            {name:__("Dictionaries"), value:"dc.format=e"},
            {name:__("Reference Books"), value:"dc.format=g"},
            {name:__("Standards"), value:"(cuba.bibLevel=m and dc.format=l)"},
            {name:__("Tutorials"), value:"dc.format=j"},
            {name:__("Encyclopedias"), value:"dc.format=f"}
        ],
        locationsList: [
            {name:__("All inventories"), value:""},
            {name:__("scientific-methodological department"), value:"НМО"},
            {name:__("scientific book inventory"), value:"НФ"},
            {name:__("rare book inventory"), value:"РФ"},
            {name:__("educational inventory"), value:"УФ"},
            {name:__("fiction book inventory"), value:"ХФ"},
            {name:__("reading room of humanitarian literature"), value:"ЧЗГЛ"},
            //
            // {name:__("reading room of library science literature"), value:"ЧЗСБИ"},
            //
            {name:__("reading room of foreign literature"), value:"ЧЗИЛ"},
            {name:"читальный зал периодических изданий", value:"ЧЗПИ"},
            {name:__("reading room for course and graduation projects"), value:"ЧЗКДП"},
            {name:__("reading room of technical literature"), value:"ЧЗТЛ"},
            {name:__("reading room of electronic resources"), value:"ЧЗЭР"},
            {name:__("department of foreign language teaching methodologies"), value:"ЯЦ_МПИЯ"},
            {name:"кафедра иностранного языка ИСГТ", value:"ЯЦ_ИСГТ"},
            {name:"кафедра иностранного языка ИПР", value:"ЯЦ_ИПР"},
            {name:"кафедра иностранного языка ИФВТ", value:"ЯЦ_ИФВТ"},
            {name:"кафедра иностранного языка ИНК", value:"ЯЦ_ИНК"},
            {name:"кафедра иностранного языка ЭНИН", value:"ЯЦ_ЭНИН"},
            {name:"кафедра иностранного языка ФТИ", value:"ЯЦ_ФТИ"},
            {name:"подготовительное отделение ИМОЯК", value:"ЯЦ_ИМОЯК_ПО"},
            {name:"языковой центр ИМОЯК, к. 312 корпус 19", value:"ЯЦ_ИМОЯК1"},
            {name:"языковой центр ИМОЯК, к. 423 корпус 19", value:"ЯЦ_ИМОЯК2"},
            {name:"языковой центр ИМОЯК, к. 518 корпус 19", value:"ЯЦ_ИМОЯК3"},
            {name:"языковой центр \"Медиатека\" ИСГТ", value:"ЯЦ_Медиатека"},
            {name:"языковой центр \"Медиатека\" ШБИП", value:"ЯЦ_ШБИП"},
            {name:"кафедра иностранного языка ИК, корпус 10", value:"ЯЦ_ИК1"},
            {name:"кафедра иностранного языка ИК", value:"ЯЦ_ИК"},
            {name:"ресурсный центр языковой подготовки", value:"ЯЦ_РЦЯП"}
        ],
        languagesList: [
            {name:__("All languages"), value:""},
            {name:__("English"), value:"eng"},
            {name:__("Russian"), value:"rus"},
            {name:__("-- List in alphabetical order --"), value:""},
            {name:__("Abaza"), value:"aba"},
            {name:__("Abkhazian"), value:"abk"},
            {name:__("Avadhi"), value:"awa"},
            {name:__("Avar"), value:"ava"},
            {name:__("Avestan"), value:"ave"},
            {name:__("Australian languages"), value:"aus"},
            {name:__("Austronesian (others)"), value:"map"},
            {name:__("Adangme"), value:"ada"},
            {name:__("Adyghe"), value:"ady"},
            {name:__("Azerbaijani"), value:"aze"},
            {name:__("Aymara"), value:"aym"},
            {name:__("Ainu"), value:"ain"},
            {name:__("Akan"), value:"aka"},
            {name:__("Akkadian"), value:"akk"},
            {name:__("Albanian"), value:"alb"},
            {name:__("Algonquian languages"), value:"alg"},
            {name:__("Aleutian"), value:"ale"},
            {name:__("-- Allemanic see Swiss German --"), value:""},
            {name:__("Altai (others)"), value:"tut"},
            {name:__("-- Amarinha see Amharic --"), value:""},
            {name:__("Amharic"), value:"amh"},
            {name:__("Angika"), value:"anp"},
            {name:__("English"), value:"eng"},
            {name:__("Anglo-Creole and Pidgin (others)"), value:"cpe"},
            {name:__("Apache languages"), value:"apa"},
            {name:__("Arab"), value:"ara"},
            {name:__("Arawak"), value:"arw"},
            {name:__("Aragonese"), value:"arg"},
            {name:__("Aramaic"), value:"arc"},
            {name:__("Arapaho"), value:"arp"},
            {name:__("Armenian"), value:"arm"},
            {name:__("Aromunsky"), value:"rup"},
            {name:__("-- Aromanian see Aromunian --"), value:""},
            {name:__("Assamese"), value:"asm"},
            {name:__("Asturian"), value:"ast"},
            {name:__("Atapach languages"), value:"ath"},
            {name:__("Afar"), value:"aar"},
            {name:__("Afrasian (others)"), value:"afa"},
            {name:__("Afrikaans"), value:"afr"},
            {name:__("Afrihili (artificial language)"), value:"afh"},
            {name:__("Akhvakhsky"), value:"akh"},
            {name:__("Aztec languages"), value:"nah"},
            {name:__("Achekh"), value:"ace"},
            {name:__("Acoli"), value:"ach"},
            {name:"-- Бабле см. Астурийский --", value:""},
            {name:"Балийский", value:"ban"},
            {name:"Балтийские (другие)", value:"bat"},
            {name:"Бамбара", value:"bam"},
            {name:"Бамилеке языки", value:"bai"},
            {name:"Банда языки", value:"bad"},
            {name:"Банту (другие)", value:"bnt"},
            {name:"Баса", value:"bas"},
            {name:"Баскский", value:"baq"},
            {name:"Батакские языки", value:"btk"},
            {name:"Башкирский", value:"bak"},
            {name:"Беджа", value:"bej"},
            {name:"Белорусский", value:"bel"},
            {name:"Белуджский", value:"bal"},
            {name:"Бемба", value:"bem"},
            {name:"Бенгальский", value:"ben"},
            {name:"Берберские (другие)", value:"ber"},
            {name:"Бикольский", value:"bik"},
            {name:"Билин", value:"byn"},
            {name:"Бини", value:"bin"},
            {name:"Бирманский", value:"bur"},
            {name:"Бислама", value:"bis"},
            {name:"Бихари", value:"bih"},
            {name:"-- Блин см. Билин --", value:""},
            {name:"Болгарский", value:"bul"},
            {name:"Боснийский", value:"bos"},
            {name:"Брауи", value:"bra"},
            {name:"Бретонский", value:"bre"},
            {name:"Бугийский", value:"bug"},
            {name:"-- Букмол, норвежский см. Норвежский букмол --", value:""},
            {name:"Бурятский", value:"bua"},
            {name:"Бходжпури", value:"bho"},
            {name:"Вай", value:"vai"},
            {name:"Вакашские языки", value:"wak"},
            {name:"-- Валенсийский см. Каталанский  --", value:""},
            {name:"Валлийский (Уэльский)", value:"wel"},
            {name:"Валлонский", value:"wln"},
            {name:"Варай", value:"war"},
            {name:"Вашо", value:"was"},
            {name:"Венгерский", value:"hun"},
            {name:"Венда", value:"ven"},
            {name:"Вепский", value:"vep"},
            {name:"Верхнелужицкий", value:"hsb"},
            {name:"-- Вогульский см. Мансийский --", value:""},
            {name:"Воламо", value:"wal"},
            {name:"Волапюк", value:"vol"},
            {name:"Волоф", value:"wol"},
            {name:"Восточный фризский", value:"frs"},
            {name:"-- Вотяцкий см. Удмуртский (вотяцкий) --", value:""},
            {name:"Вьетнамский", value:"vie"},
            {name:"Га", value:"gaa"},
            {name:"Гавайский", value:"haw"},
            {name:"Гагаузский", value:"gag"},
            {name:"Гаитянские", value:"hat"},
            {name:"Гайо", value:"gay"},
            {name:"Галисийский", value:"glg"},
            {name:"Ганда", value:"lug"},
            {name:"Гаэльский", value:"gla"},
            {name:"Гбая", value:"gba"},
            {name:"Гвичин", value:"gwi"},
            {name:"Гереро", value:"her"},
            {name:"Германские (другие)", value:"gem"},
            {name:"Геэз (Эфиопский)", value:"gez"},
            {name:"Гильбертский", value:"gil"},
            {name:"Гольдский (Нанайский)", value:"gol"},
            {name:"Гонди", value:"gon"},
            {name:"Горонтало", value:"gor"},
            {name:"Готский", value:"got"},
            {name:"Гребо", value:"grb"},
            {name:"Греческий (новогреческий)", value:"gre"},
            {name:"Грузинский", value:"geo"},
            {name:"Гуарани", value:"grn"},
            {name:"Гуарани", value:"gua"},
            {name:"Гуджарати", value:"guj"},
            {name:"Дакота", value:"dak"},
            {name:"Даргинский", value:"dar"},
            {name:"Датский", value:"dan"},
            {name:"Датский", value:"dut"},
            {name:"Даякские языки", value:"day"},
            {name:"Делаварский", value:"del"},
            {name:"Дзонг-кэ", value:"dzo"},
            {name:"Дивехи", value:"div"},
            {name:"-- Димли см. Заза --", value:""},
            {name:"Динка", value:"din"},
            {name:"Диула (Дьюла)", value:"dyu"},
            {name:"Догри", value:"doi"},
            {name:"Догриб", value:"dgr"},
            {name:"Дравидийские (другие)", value:"dra"},
            {name:"Древнегреческий", value:"grc"},
            {name:"Древнеегипетский", value:"egy"},
            {name:"Дуала", value:"dua"},
            {name:"Дунганский", value:"dun"},
            {name:"Еврейско-арабский", value:"jrb"},
            {name:"Еврейско-персидский", value:"jpr"},
            {name:"Заза", value:"zza"},
            {name:"-- Зазаки см. Заза --", value:""},
            {name:"Занди языки", value:"znd"},
            {name:"Западный фризский", value:"fry"},
            {name:"Зарезервировано для локального использования", value:"qaa"},
            {name:"Зенагский", value:"zen"},
            {name:"Знаков языки", value:"sgn"},
            {name:"Зулу", value:"zul"},
            {name:"Зуньи", value:"zun"},
            {name:"Ибанский", value:"iba"},
            {name:"Иврит", value:"heb"},
            {name:"Игбо", value:"ibo"},
            {name:"Иджо языки", value:"ijo"},
            {name:"Идиш", value:"yid"},
            {name:"Идо", value:"ido"},
            {name:"Илоко", value:"ilo"},
            {name:"Инари-саамский", value:"smn"},
            {name:"Ингушский", value:"inh"},
            {name:"Индийские (другие)", value:"inc"},
            {name:"Индоевропейские (другие)", value:"ine"},
            {name:"Индонезийский", value:"ind"},
            {name:"Интерлингва", value:"ina"},
            {name:"Интерлингва", value:"int"},
            {name:"Интерлингве", value:"ile"},
            {name:"Инуктитут", value:"iku"},
            {name:"Инупиак", value:"ipk"},
            {name:"Иранские (другие)", value:"ira"},
            {name:"Ирландский", value:"gle"},
            {name:"Ирландский", value:"iri"},
            {name:"Ирокезские языки", value:"iro"},
            {name:"Искусственные (другие)", value:"art"},
            {name:"Исландский", value:"ice"},
            {name:"Испанский", value:"spa"},
            {name:"Итальянский", value:"ita"},
            {name:"Ительменский", value:"ite"},
            {name:"Йоруба", value:"yor"},
            {name:"Кабардинский", value:"kbd"},
            {name:"Кабили", value:"kab"},
            {name:"Кави", value:"kaw"},
            {name:"Кавказские (другие)", value:"cau"},
            {name:"Каддо", value:"cad"},
            {name:"Казахский", value:"kaz"},
            {name:"Калмыцкий", value:"xal"},
            {name:"Камба", value:"kam"},
            {name:"Каннада", value:"kan"},
            {name:"Канури", value:"kau"},
            {name:"Караимский", value:"kai"},
            {name:"Каракалпакский", value:"kaa"},
            {name:"Карачаево-балкарский", value:"krc"},
            {name:"Карельский", value:"krl"},
            {name:"Каренские языки", value:"kar"},
            {name:"Карибский Галиби", value:"car"},
            {name:"Кастильский испанский", value:"spa"},
            {name:"Каталанский", value:"cat"},
            {name:"Качин", value:"kac"},
            {name:"Кашмири", value:"kas"},
            {name:"Кашубианский", value:"csb"},
            {name:"Кельтские (другие)", value:"cel"},
            {name:"Кечуа", value:"que"},
            {name:"Кикуйю; Гикуйю", value:"kik"},
            {name:"Кимбунду", value:"kmb"},
            {name:"Киньяма", value:"kua"},
            {name:"Киньяруанда", value:"kin"},
            {name:"Киргизский", value:"kir"},
            {name:"Китайский", value:"chi"},
            {name:"Клингон", value:"tlh"},
            {name:"Койсанские (другие)", value:"khi"},
            {name:"Коми", value:"kom"},
            {name:"Коми-пермяцкий", value:"pem"},
            {name:"Конго", value:"kon"},
            {name:"Конкани", value:"kok"},
            {name:"Коптский", value:"cop"},
            {name:"Корейский", value:"kor"},
            {name:"Корнский", value:"cor"},
            {name:"Корсиканский", value:"cos"},
            {name:"Корякский", value:"koy"},
            {name:"Коса", value:"xho"},
            {name:"Косраенский", value:"kos"},
            {name:"Кпелле", value:"kpe"},
            {name:"-- Креольские гаитянские см. Гаитянские --", value:""},
            {name:"Креольские и пиджины (другие)", value:"crp"},
            {name:"Кри", value:"cre"},
            {name:"Крик", value:"mus"},
            {name:"Кру языки", value:"kro"},
            {name:"Крымско-татарский", value:"crh"},
            {name:"Кумыкский", value:"kum"},
            {name:"Курдский", value:"kur"},
            {name:"Курух", value:"kru"},
            {name:"Кусайе", value:"kos"},
            {name:"Кусайе", value:"kus"},
            {name:"Кутенаи", value:"kut"},
            {name:"Кушитские (другие)", value:"cus"},
            {name:"Кхаси", value:"kha"},
            {name:"Кхмерский", value:"cam"},
            {name:"Ладино", value:"lad"},
            {name:"Лакский", value:"lak"},
            {name:"Ламба", value:"lam"},
            {name:"Лаосский", value:"lao"},
            {name:"Латинский", value:"lat"},
            {name:"Латышский", value:"lav"},
            {name:"Лахнда", value:"lah"},
            {name:"Лезгинский", value:"lez"},
            {name:"Лимбургийский", value:"lim"},
            {name:"Лингала", value:"lin"},
            {name:"Литовский", value:"lit"},
            {name:"Ложбан", value:"jbo"},
            {name:"Лози", value:"loz"},
            {name:"Луба-Катанга", value:"lub"},
            {name:"Луба-Лулуа", value:"lua"},
            {name:"Лужицкие языки", value:"wen"},
            {name:"Луисеньо", value:"lui"},
            {name:"Луле-саамский", value:"smj"},
            {name:"Лунда", value:"lun"},
            {name:"Луо (Кения и Танзания)", value:"luo"},
            {name:"Лушей", value:"lus"},
            {name:"Люксембургский", value:"ltz"},
            {name:"Магахи", value:"mag"},
            {name:"Мадурский", value:"mad"},
            {name:"Майтхили", value:"mai"},
            {name:"Майя языки", value:"myn"},
            {name:"Макассарский", value:"mak"},
            {name:"-- Македоно-румынский см. Аромунский --", value:""},
            {name:"Македонский", value:"mac"},
            {name:"Малагасийский", value:"mlg"},
            {name:"Малайский", value:"may"},
            {name:"Малаялам", value:"mal"},
            {name:"-- Мальдивский см. Дивехи --", value:""},
            {name:"Мальтийский", value:"mlt"},
            {name:"Мандарский", value:"mdr"},
            {name:"Мандинго", value:"man"},
            {name:"Манипурский", value:"mni"},
            {name:"Манобо языки", value:"mno"},
            {name:"Мансийский", value:"vog"},
            {name:"Маньчжурский", value:"mnc"},
            {name:"Маори", value:"mao"},
            {name:"Мапуче", value:"arn"},
            {name:"Маратхи", value:"mar"},
            {name:"Марвари", value:"mwr"},
            {name:"Марийский", value:"chm"},
            {name:"Маршальский", value:"mah"},
            {name:"Масаи", value:"mas"},
            {name:"Менде", value:"men"},
            {name:"Микмак", value:"mic"},
            {name:"Минангкабау", value:"min"},
            {name:"Мирандский", value:"mwl"},
            {name:"Моей", value:"mos"},
            {name:"Мокша", value:"mdf"},
            {name:"Молдавский", value:"mol"},
            {name:"Монго", value:"lol"},
            {name:"Монгольский", value:"mon"},
            {name:"Монкхмерские (другие)", value:"mkh"},
            {name:"Мохаук", value:"moh"},
            {name:"Мунда языки", value:"mun"},
            {name:"Мэнкский", value:"glv"},
            {name:"Мэнкский", value:"max"},
            {name:"Навахо", value:"nav"},
            {name:"Науру", value:"nau"},
            {name:"Ндебеле Северный ", value:"nde"},
            {name:"Ндебеле Южный", value:"nbl"},
            {name:"Ндонга", value:"ndo"},
            {name:"Не определено", value:"und"},
            {name:"Неаполитанский", value:"nap"},
            {name:"Невари (классический)", value:"nwc"},
            {name:"Неварский", value:"new"},
            {name:"Немецкий", value:"ger"},
            {name:"Ненецкий (Юрако-Самоедский)", value:"yur"},
            {name:"Непальский", value:"nep"},
            {name:"Нет языкового материала", value:"zxx"},
            {name:"Нзима", value:"nzi"},
            {name:"Ниасский", value:"nia"},
            {name:"Нивхский", value:"giy"},
            {name:"Нигер-Кордофанские (другие)", value:"nic"},
            {name:"Нидерландский, средневековый", value:"dum"},
            {name:"Нижнегерманский; Нижнесаксонский", value:"nds"},
            {name:"Нижнелужицкий", value:"dsb"},
            {name:"-- Нижнесаксонский см. Нижнегерманский  --", value:""},
            {name:"Нило-сахарские (другие)", value:"ssa"},
            {name:"Ниуэ", value:"niu"},
            {name:"Н'Ко", value:"nqo"},
            {name:"-- Новонорвежский см. Нюнорск --", value:""},
            {name:"Ногай", value:"nog"},
            {name:"Норвежский", value:"nor"},
            {name:"Норвежский букмол", value:"nob"},
            {name:"Нубийские языки", value:"nub"},
            {name:"Ньоро", value:"nyo"},
            {name:"Ньямвези", value:"nym"},
            {name:"Ньянджа", value:"nya"},
            {name:"Ньянколе", value:"nyn"},
            {name:"Нюнорск (Новонорвежский)", value:"nno"},
            {name:"Оджибва", value:"oji"},
            {name:"Окситанский", value:"oci"},
            {name:"Окситанский", value:"lan"},
            {name:"Ория", value:"ori"},
            {name:"Оромо", value:"orm"},
            {name:"Оромо", value:"gal"},
            {name:"Оседжи", value:"osa"},
            {name:"Осетинский", value:"oss"},
            {name:"Отомангские языки", value:"oto"},
            {name:"Палау", value:"pau"},
            {name:"Пали", value:"pli"},
            {name:"Пампанга", value:"pam"},
            {name:"Пангасинан", value:"pag"},
            {name:"Панджаби", value:"pan"},
            {name:"Папуасские (другие)", value:"paa"},
            {name:"Папьяменто", value:"pap"},
            {name:"Персидский", value:"per"},
            {name:"Пехлевийский", value:"pal"},
            {name:"Польский", value:"pol"},
            {name:"Понапе", value:"pon"},
            {name:"Португало-креольские и пиджины (другие)", value:"cpp"},
            {name:"Португальский", value:"por"},
            {name:"Пракриты языки", value:"pra"},
            {name:"Пушту", value:"pus"},
            {name:"Раджастхани", value:"raj"},
            {name:"Разных семей языки", value:"mul"},
            {name:"Рапануй", value:"rap"},
            {name:"Раротонганский", value:"rar"},
            {name:"Романские (другие)", value:"roa"},
            {name:"Романский", value:"roh"},
            {name:"Румынский", value:"rum"},
            {name:"Рунди", value:"run"},
            {name:"Русский", value:"rus"},
            {name:"Саамские", value:"lap"},
            {name:"Саамские языки (другие)", value:"smi"},
            {name:"Саамский (северный)", value:"sme"},
            {name:"Саамский (южный)", value:"sma"},
            {name:"Салишские языки", value:"sal"},
            {name:"Самаритянский арамейский", value:"sam"},
            {name:"Самоанский", value:"smo"},
            {name:"Самоанский", value:"sao"},
            {name:"Санго", value:"sag"},
            {name:"Сандаве", value:"sad"},
            {name:"Санскрит", value:"san"},
            {name:"Сантали", value:"sat"},
            {name:"Сапотекский", value:"zap"},
            {name:"Сардинский", value:"srd"},
            {name:"Сасакский", value:"sas"},
            {name:"Свази", value:"ssw"},
            {name:"Свази", value:"swz"},
            {name:"Себуано", value:"ceb"},
            {name:"Северной Америки индейцев", value:"nai"},
            {name:"-- Северный Ндебеле см. Ндебеле Северный  --", value:""},
            {name:"Северный фризский", value:"frr"},
            {name:"Селькупский", value:"sel"},
            {name:"Семитские (другие)", value:"sem"},
            {name:"Сербский", value:"scc"},
            {name:"Серер", value:"srr"},
            {name:"Сидама", value:"sid"},
            {name:"Сиксика", value:"bla"},
            {name:"Сингальский", value:"sin"},
            {name:"Сингальский", value:"snh"},
            {name:"Синджи", value:"snd"},
            {name:"Синотибетские (другие)", value:"sit"},
            {name:"Сирийский", value:"syr"},
            {name:"Сиу языки", value:"sio"},
            {name:"Сицилийский ", value:"scn"},
            {name:"Сичуань", value:"iii"},
            {name:"Сколт; колтта-саамский", value:"sms"},
            {name:"Славянские (другие)", value:"sla"},
            {name:"Словацкий", value:"slo"},
            {name:"Словенский", value:"slv"},
            {name:"Слэйв (Атапачский)", value:"den"},
            {name:"Смешанные (другие) языки ", value:"mis"},
            {name:"Согдийский", value:"sog"},
            {name:"Сомали", value:"som"},
            {name:"Сонгаи языки", value:"son"},
            {name:"Сонинкийский", value:"snk"},
            {name:"Сото", value:"sso"},
            {name:"Сото северный", value:"nso"},
            {name:"Сото южный", value:"sot"},
            {name:"Среднеанглийский", value:"enm"},
            {name:"Средневерхненемецкий", value:"gmh"},
            {name:"Среднеирландский", value:"mga"},
            {name:"Среднефранцузский", value:"frm"},
            {name:"Староанглийский", value:"ang"},
            {name:"Староверхненемецкий", value:"goh"},
            {name:"Староирландский", value:"sga"},
            {name:"Старонорвежский", value:"non"},
            {name:"Староперсидский", value:"peo"},
            {name:"Старопровансальский", value:"pro"},
            {name:"-- Старославянский см. Церковнославянский --", value:""},
            {name:"Старотурецкий", value:"ota"},
            {name:"Старофранцузский", value:"fro"},
            {name:"Суахили", value:"swa"},
            {name:"Сукума", value:"suk"},
            {name:"Сунданский", value:"sun"},
            {name:"Суринамский", value:"srn"},
            {name:"Сусу", value:"sus"},
            {name:"Табасаранский", value:"tab"},
            {name:"Тагалог", value:"tgl"},
            {name:"Тагалог", value:"tag"},
            {name:"Таджикский", value:"tgk"},
            {name:"Таджикский", value:"taj"},
            {name:"Таитянский", value:"tah"},
            {name:"Тайские (другие)", value:"tai"},
            {name:"Тайский", value:"tha"},
            {name:"Талышский", value:"tal"},
            {name:"Тамашек", value:"tmh"},
            {name:"Тамильский", value:"tam"},
            {name:"Татарский", value:"tat"},
            {name:"Татарский", value:"tar"},
            {name:"Тви", value:"twi"},
            {name:"Телугу", value:"tel"},
            {name:"Темне", value:"tem"},
            {name:"Терено", value:"ter"},
            {name:"Тетум", value:"tet"},
            {name:"Тибетский", value:"tib"},
            {name:"Тиви", value:"tiv"},
            {name:"Тигре", value:"tig"},
            {name:"Тигринья", value:"tir"},
            {name:"Тлингит", value:"tli"},
            {name:"Токелайский", value:"tkl"},
            {name:"Ток-Писин", value:"tpi"},
            {name:"Тонга (Ньяса)", value:"tog"},
            {name:"Тонга (островов Тонга)", value:"ton"},
            {name:"Трук", value:"tru"},
            {name:"Тсвана", value:"tsn"},
            {name:"Тсвана", value:"tsw"},
            {name:"Тсонга", value:"tso"},
            {name:"Тувалу", value:"tvl"},
            {name:"Тувинский", value:"tyv"},
            {name:"Тумбука", value:"tum"},
            {name:"Тупи языки", value:"tup"},
            {name:"Турецкий", value:"tur"},
            {name:"Туркменский", value:"tuk"},
            {name:"Угаритский", value:"uga"},
            {name:"Удмуртский", value:"udm"},
            {name:"Удмуртский (вотяцкий)", value:"vot"},
            {name:"Удэгейский", value:"ude"},
            {name:"Узбекский", value:"uzb"},
            {name:"Уйгурский", value:"uig"},
            {name:"Украинский", value:"ukr"},
            {name:"Ульчский", value:"ulc"},
            {name:"Умбунду", value:"umb"},
            {name:"Урду", value:"urd"},
            {name:"Фанг", value:"fan"},
            {name:"Фанти", value:"fat"},
            {name:"Фарерский", value:"fao"},
            {name:"Фарерский", value:"far"},
            {name:"Фиджи", value:"fij"},
            {name:"Филиппинские (другие)", value:"phi"},
            {name:"Филиппинский", value:"fil"},
            {name:"Финикийские", value:"phn"},
            {name:"Финно-угорсике (другие)", value:"fiu"},
            {name:"Финский", value:"fin"},
            {name:"Фон", value:"fon"},
            {name:"Франко-креольские и пиджины (другие)", value:"cpf"},
            {name:"Французский", value:"fre"},
            {name:"Фризский", value:"fri"},
            {name:"-- Фризский восточный см. Восточный фризский --", value:""},
            {name:"-- Фризский западный см. Западный фризский --", value:""},
            {name:"-- Фризский северный см. Северный фризский --", value:""},
            {name:"-- Фризский южный см. Южный фризский --", value:""},
            {name:"Фриульский", value:"fur"},
            {name:"Фулах", value:"ful"},
            {name:"Хайда", value:"hai"},
            {name:"Хакасский", value:"khk"},
            {name:"Хантыйский", value:"ost"},
            {name:"Хауса", value:"hau"},
            {name:"Хетский", value:"hit"},
            {name:"Хилигайнон", value:"hil"},
            {name:"Химачали", value:"him"},
            {name:"Хинди", value:"hin"},
            {name:"Хиримоту", value:"hmo"},
            {name:"Хмонг", value:"hmn"},
            {name:"Хорватский", value:"scr"},
            {name:"Хотанский", value:"kho"},
            {name:"Хупа", value:"hup"},
            {name:"Цахурский", value:"tsa"},
            {name:"Центральной Америки индейцев (другие)", value:"cai"},
            {name:"Центральный кхмерский", value:"khm"},
            {name:"Церковнославянский; Старославянский", value:"chu"},
            {name:"Цимшиан", value:"tsi"},
            {name:"Цыганский", value:"rom"},
            {name:"Чагатайский", value:"chg"},
            {name:"Чаморро", value:"cha"},
            {name:"Чамские языки", value:"cmc"},
            {name:"Чейенн", value:"chy"},
            {name:"Чероки", value:"chr"},
            {name:"Чеченский", value:"che"},
            {name:"Чешский", value:"cze"},
            {name:"Чжуань", value:"zha"},
            {name:"Чибча", value:"chb"},
            {name:"Чинук жаргон", value:"chn"},
            {name:"Чипевьян", value:"chp"},
            {name:"Чоктав", value:"cho"},
            {name:"Чувашский", value:"chv"},
            {name:"Чукотский", value:"chk"},
            {name:"Шанский", value:"shn"},
            {name:"Шведский", value:"swe"},
            {name:"Швейцарский немецкий; Аллеманский", value:"gsw"},
            {name:"Шона", value:"sna"},
            {name:"Шона", value:"sho"},
            {name:"Шорский", value:"sho"},
            {name:"Шотландский", value:"sco"},
            {name:"-- Шотландский гаэльский см. Гаэльский --", value:""},
            {name:"Шумерский", value:"sux"},
            {name:"Шунганский", value:"shu"},
            {name:"Эве", value:"ewe"},
            {name:"Эвенкийский (тунгусский)", value:"tun"},
            {name:"Эвенский", value:"lau"},
            {name:"Эвондо", value:"ewo"},
            {name:"Эдо", value:"bin"},
            {name:"-- Эдо см. Бини --", value:""},
            {name:"Экаджук", value:"eka"},
            {name:"Эламский", value:"elx"},
            {name:"Эрзя", value:"myv"},
            {name:"Эскимосские языки", value:"esk"},
            {name:"Эскимосский (гренландский)", value:"kal"},
            {name:"Эсперанто", value:"epo"},
            {name:"Эсперанто", value:"esp"},
            {name:"Эстонский", value:"est"},
            {name:"Эфик", value:"efi"},
            {name:"Эфиопский", value:"eth"},
            {name:"Южно-алтайский язык", value:"alt"},
            {name:"Южной Америки индейцев (другие)", value:"sai"},
            {name:"-- Южный Ндебеле см. Ндебеле Южный --", value:""},
            {name:"Юкагирский", value:"yuk"},
            {name:"Юпик языки", value:"ypk"},
            {name:"Яванский", value:"jav"},
            {name:"Якутский", value:"sah"},
            {name:"Яо", value:"yao"},
            {name:"Яп", value:"yap"},
            {name:"Японский", value:"jpn"}
        ]
    })
    .filter('ogTitle', [function() {
        return function(input) {
            var content = null ;
            if (input['bib:record']['bib:level0']) {
                content = input['bib:record']['bib:level0'][0]['bib:domain1'][0];
            }
            if (input['bib:record']['bib:level1']) {
                content = input['bib:record']['bib:level1'][0]['bib:domain1'][0];
                if (input['bib:record']['bib:level2']) {
                    content = content + '. ' + input['bib:record']['bib:level2'][0]['bib:domain1'][0];
                }
            }
            if (input['bib:record']['bib:domain-authorities-header']) {
                content = input['bib:record']['bib:domain-authorities-header'][0];
            }
            return content;
        }
    }])
    .filter('ogDescription', [function() {
        return function(input) {
            var content = null;
            if (input['bib:record']['bib:referat']) {
                content = input['bib:record']['bib:referat'][0];
            }
            if (content === null) {
                if (input['bib:record']['bib:level0']) {
                    content = input['bib:record']['bib:level0'][0]['bib:domain1'][0];
                }
                if (input['bib:record']['bib:level1']) {
                    content = input['bib:record']['bib:level1'][0]['bib:domain1'][0];
                    if (input['bib:record']['bib:level2']) {
                        content = content + '. ' + input['bib:record']['bib:level2'][0]['bib:domain1'][0];
                    }
                }
                if (input['bib:record']['bib:domain-authorities-header']) {
                    content = input['bib:record']['bib:domain-authorities-header'][0];
                }
            }
            return content;
        }
    }])
    .filter('ogKeywords', [function() {
        return function(input) {
            var content = null;
            if (input['bib:record']['bib:subjects']) {
                content = input['bib:record']['bib:subjects'].join('; ');
            }
            if (content === null) {
                if (input['bib:record']['bib:level0']) {
                    content = input['bib:record']['bib:level0'][0]['bib:domain1'][0];
                }
                if (input['bib:record']['bib:level1']) {
                    content = input['bib:record']['bib:level1'][0]['bib:domain1'][0];
                    if (input['bib:record']['bib:level2']) {
                        content = content + '. ' + input['bib:record']['bib:level2'][0]['bib:domain1'][0];
                    }
                }
                if (input['bib:record']['bib:domain-authorities-header']) {
                    content = input['bib:record']['bib:domain-authorities-header'][0];
                }
            }
            return content;
        }
    }])
    .name;


if (!String.prototype.includes) {
    String.prototype.includes = function(search, start) {
        'use strict';
        if (typeof start !== 'number') {
            start = 0;
        }
        if (start + search.length > this.length) {
            return false;
        } else {
            return this.indexOf(search, start) !== -1;
        }
    };
}
